import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./PremiumNuts.css";

export default function PremiumNuts() {
    const premiumNutsProducts = [
        {
            id: 1,
            name: "HAZELNUTS",
            image: "/assets/img/Premium Nuts/Hazelnuts.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Chocolate manufacturing",
                        "Premium bakery products",
                        "Nut spreads",
                        "Confectionery industry",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Rich nutty flavor",
                        "Premium quality ingredient",
                        "High nutritional value",
                        "Popular in desserts",
                    ],
                },
            ],
        },

        {
            id: 2,
            name: "MACADAMIA NUTS",
            image: "/assets/img/Premium Nuts/Macadamia-Nuts.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Luxury chocolates",
                        "Premium snacks",
                        "Bakery products",
                        "Desserts",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Creamy texture",
                        "Rich buttery flavor",
                        "Premium nut variety",
                        "High healthy fat content",
                    ],
                },
            ],
        },

        {
            id: 3,
            name: "PECANS",
            image: "/assets/img/Premium Nuts/Pecans.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Pies and desserts",
                        "Bakery products",
                        "Premium snack mixes",
                        "Confectionery items",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Sweet buttery taste",
                        "Rich nutrient profile",
                        "Excellent texture",
                        "Premium food ingredient",
                    ],
                },
            ],
        },

        {
            id: 4,
            name: "BRAZIL NUTS",
            image: "/assets/img/Premium Nuts/Brazil-Nuts.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Health food products",
                        "Snack mixes",
                        "Bakery applications",
                        "Nutritional supplements",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Rich in selenium",
                        "Excellent nutritional value",
                        "Large crunchy texture",
                        "Supports healthy diets",
                    ],
                },
            ],
        },

        {
            id: 5,
            name: "PINE NUTS (CHILGOZA)",
            image: "/assets/img/Premium Nuts/Pine-Nuts-Chilgoza.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Luxury food products",
                        "Traditional cuisines",
                        "Premium snack mixes",
                        "Bakery applications",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Unique buttery flavor",
                        "Rich in nutrients",
                        "Rare premium nut",
                        "High market value",
                    ],
                },
            ],
        },
    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb
                title="Premium Nuts"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Premium Nuts Product Range</h1>

                    <p className="pp-subtitle">
                        Explore our premium quality nuts sourced from trusted suppliers
                        worldwide.
                    </p>

                    <div className="pp-grid">
                        {premiumNutsProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>

                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>

                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div
                            className="modal-overlay"
                            onClick={() => setSelectedProduct(null)}
                        >
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />

                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>

                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="close-btn"
                                    onClick={() => setSelectedProduct(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}